import { useEffect } from 'react';

import { useViewerAnalytics } from '../hooks';
import { useGlobalStore } from '../state/globalStore';
import { BP_EVENT_NAMES } from '../utils/bpUtils/constants';
import { PREVIEW_TYPE } from '../utils/constants';
import { BackgroundWrapper } from './background-wrapper';
import { ConfirmationView } from './confirmation-view';
import { LoginView } from './login-view';
import { RegistrationView } from './registration-view';
import RegistrationFull from './registration-view/RegistrationFull';

export const Preview = () => {
  const previewType = useGlobalStore((store) => store.previewType);
  const { sendRegistrationFormViewedEvent } = useViewerAnalytics();

  /** Log form impression for viewer side */
  useEffect(() => {
    if (([PREVIEW_TYPE.FORM, PREVIEW_TYPE.LOGIN_SCREEN] as string[]).includes(previewType)) {
      sendRegistrationFormViewedEvent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BackgroundWrapper disableBackground={previewType === PREVIEW_TYPE.FORM_FULL}>
      {previewType === PREVIEW_TYPE.CONFIRMATION && <ConfirmationView />}
      {previewType === PREVIEW_TYPE.LOGIN_SCREEN && <LoginView />}
      {previewType === PREVIEW_TYPE.FORM && <RegistrationView />}
      {previewType === PREVIEW_TYPE.FORM_FULL && <RegistrationFull />}
    </BackgroundWrapper>
  );
};
